import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class GetCarrierIntegrationsCommand extends IRequestCommand<
  IGetCarrierIntegrationsResponse,
  ErrorDetails,
  IGetCarrierIntegrationsParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'api/carrier/{carrierUserId}/paginated?page=1&size=9999&column=id&sort=DESC&magiisApi=true';
  public override setParameters(parameters: IGetCarrierIntegrationsParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
  }
}

export interface IGetCarrierIntegrationsParameters extends ICommandParameters {
  carrierUserId: string;
}

export interface IntegrationItem {
  id: number;
  applicationName: string;
  roleName: string;
  enabled: boolean;
  blocked: boolean;
}

export interface IGetCarrierIntegrationsResponse extends ICommandResponse {
  content: IntegrationItem[];
  totalElements: number;
}
